import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const TaskPrimaryActionsButton: moduleStyleType = {
    container: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'flex-end',
    },
    primaryActionHelperTextContainer: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
    },
    item: {
        marginRight: 1,
    },
    text: {
        color: 'text.secondary',
    },
    processingText: {
        color: 'text.primary',
    },
    processingIcon: {
        color: 'text.primary',
    },
    warningIcon: {
        color: 'warning.main',
    },
    iconContainer: {
        display: 'flex',
        marginRight: 1,
    },
    approveIcon: {
        color: 'success.main',
    },
    denyIcon: {
        color: 'error.main',
    },
}
